export const Input = ({
  label,
  sublabel,
  type,
  placeholder,
  validation,
  submit,
  name,
  value,
  onInputChange,
  disabled
}) => {
  return (
    <>
      <label className="form-label text-gray-600 mb-0">
        {label} <span className="text-gray-300 fs-sm">{sublabel}</span>
      </label>
      <input
        type={type}
        className={`form-control ${validation && submit && "border-danger"}`}
        placeholder={placeholder}
        name={name}
        value={value ?? ""}
        onChange={onInputChange}
        disabled={disabled}
      />
      {validation && submit && (
        <span className="text-danger">{validation}</span>
      )}
    </>
  );
};
